/** Format a number to at most 3 decimal places, stripping trailing zeros. */
export const fmt3 = (v) => {
  if (v == null) return '0';
  const n = Number(v);
  return Number.isFinite(n) ? parseFloat(n.toFixed(3)).toString() : String(v);
};

export default fmt3;
